var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHandLeft = function SvgHandLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 37,
    height: 35,
    viewBox: "0 0 0.89 0.86",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.61.85C.78.79.73.62.83.47.85.44.93.35.85.34.72.32.72.55.62.55.56.54.6.34.6.29.6.24.63.04.6.01.58-.02.52.02.51.07.5.12.53.35.48.34.44.34.46-.01.36.03.27.07.42.37.36.36.3.35.26.2.25.16.23 0 .07.05.15.18c.02.03.13.2.09.23C.22.43.12.21.07.22c-.23.06.15.24.18.42.03.19.23.25.36.21z",
    fill: "#000"
  })));
};

export default SvgHandLeft;